import styled from 'styled-components';
import { darken } from 'polished';

import backgrond from '../../assets/sign-in_background.png';

import { fade } from './animations';

export const Container = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 700px;
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  animation: ${fade} 1s;
  > div {
    display: flex;
    flex-direction: column;
    padding-bottom: 15px;
    align-items: center;
    text-align: center;
    border-bottom: 1px solid #e6e6e6;
    img {
      margin-bottom: 30px;
    }
    span {
      font-weight: 300;
      color: #9e9e9e;
    }
  }
  form {
    margin: 40px;
    width: 340px;
    text-align: center;
    > a {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      color: #021655;
      text-decoration: none;
      font-weight: 500;
      transition: all 0.2s ease-in-out;
      svg {
        margin-right: 5px;
      }
      a:hover {
        color: ${darken(0.025, '#021655')};
      }
    }
  }
  aside {
    display: flex;
    flex-direction: column;
    align-items: center;
    span.contato {
      font-size: 16px;
      color: #808080;
      a {
        text-decoration: none;
        color: #021655;
        font-weight: 700;
        transition: color 0.2s ease-in-out;
        &:hover {
          color: ${darken(0.025, '#003399')};
        }
      }
    }
    p {
      text-align: center;
      font-size: 13px;
      color: #999999;
      strong {
        color: #003399;
      }
      span {
        display: block;
      }
    }
  }
`;

export const Background = styled.div`
  flex: 1;
  background: url(${backgrond}) no-repeat center;
  background-size: cover;
`;
